import { useCallback, useMemo } from 'react'
import { FormikHelpers } from 'formik'
import { useParams } from 'react-router-dom'
import { FormOptions } from '@shared/modules/form/types'
import { AppointmentProductFormData } from '../types'
import { AppointmentsService } from '../services'
import { message } from 'antd'
import { useBackgroundNavigate } from '@shared/hooks'

type UseTransferFormProps = FormOptions

export const useAppointmentProductForm = ({ redirectUrl }: UseTransferFormProps) => {
  const { id = '' } = useParams<{ id?: string }>()
  const navigate = useBackgroundNavigate()

  const initialValues = useMemo<AppointmentProductFormData>(
    () => ({
      id,
      productId: '',
      doctorId: '',
      warehouseId: '',
      consumptionDate: null,
      quantity: '',
      discount: '',
    }),
    [id],
  )

  const onSubmit = useCallback(
    async (values: AppointmentProductFormData, helpers: FormikHelpers<AppointmentProductFormData>) => {
      helpers.setStatus(null)
      const result = await AppointmentsService.createProduct(values)

      if (result.status === 200) {
        if (redirectUrl) {
          navigate(redirectUrl)
        } else {
          helpers.resetForm()
        }
        message.success(result.data)
      } else if (result.status === 422) {
        helpers.setErrors(result.data)
      } else {
        helpers.setStatus({ type: 'error', message: result.data })
      }
    },
    [navigate, redirectUrl],
  )

  return { initialValues, onSubmit }
}
